import Svg, { Path } from "react-native-svg";
const ErrorIcon = (props: any) => (
  <Svg
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    size={18}
    color="#DC2804"
    {...props}
  >
    <Path
      d="M11.998 2c-5.525 0-10 4.475-10 10 0 5.524 4.475 10 10 10s10-4.476 10-10c0-5.525-4.475-10-10-10zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      fill="#DC2804"
    />
  </Svg>
);
export default ErrorIcon;
